import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React from 'react';

import { transformArticleData } from '../../utils';
import CardTextBasedXSmallVariant from '../Cards/CardTextBased/CardTextBasedXSmallVariant';
import Link from '../Link';
import ListPrimary from '../Lists/ListPrimary';
import TitleLabel from '../Titles/TitleLabel';
import TitleStrip from '../Titles/TitleStrip';

const TITLE = 'Workshop';
const LINK = {
  title: 'View All Workshop',
  url: '/workshop/',
};

const HomepageWorkshop = ({
  description,
  featured: _featured,
  latestArticlesWorkshop,
  radar,
}) => {
  const featured = transformArticleData(_featured);
  return (
    <div
      className="maxed:mx-auto maxed:w-[1920px] border-t border-b maxed:border-r border-smoke bg-snow relative"
      data-module-id="homepage_workshop"
    >
      <div className="absolute top-0 bottom-0 left-0 z-30 w-2 sm:w-3 lg:w-4 bg-campari" />
      <TitleStrip description={description} link={LINK} title={TITLE} />
      <div className="homepage-grid-container sm:mt-6 lg:mt-16 sm:mb-6 lg:mb-16">
        {/* articles */}
        <div
          className="grid sm:grid-cols-2 lg:grid-cols-1 sm:gap-x-4 col-span-full lg:col-end-9 "
          data-component-id="homepage_workshop_articles"
        >
          {latestArticlesWorkshop.slice(0, 4).map((data) => {
            const {
              date,
              slug,
              tags: _tags,
              title,
            } = transformArticleData(data);
            console.log("DATA", date)

            return (
              <CardTextBasedXSmallVariant
                key={data.id}
                date={date}
                slug={slug}
                tags={_tags}
                title={title}
              />
            );
          })}
        </div>
        {/* featured + radar */}
        <div
          className="h-64 col-span-12 mt-12 sm:h-auto sm:col-span-6 lg:col-span-6 lg:col-start-10 sm:mt-14 lg:mt-0"
          data-component-id="homepage_workshop_featured"
        >
          <Link to={featured?.url}>
            <GatsbyImage
              alt={featured?.description}
              className="image-hover"
              image={getImage(featured?.cardImage)}
              style={{ height: '100%' }}
            />
          </Link>
        </div>
        <div className="flex flex-col justify-between col-span-12 sm:col-span-6 lg:col-span-5 sm:mt-14 lg:mt-0">
          <div className="mt-6 mb-16 sm:mt-0 sm:mb-0 ">
            <div className="flex flex-col">
              <TitleLabel tags={featured?.tags} />
              <Link to={featured?.url}>
                <h4 className="mt-2 stink-h4 text-hover">{featured?.title}</h4>
              </Link>
            </div>
          </div>

          {/* radar */}
          <ListPrimary
            body={radar}
            data-component-id="homepage_workshop_radar"
            listTitle="Courier Radar"
          />
        </div>
      </div>
    </div>
  );
};

HomepageWorkshop.propTypes = {
  description: PropTypes.string,
  featured: PropTypes.object,
  latestArticlesWorkshop: PropTypes.array,
  radar: PropTypes.array,
};

export default HomepageWorkshop;
